export default "__VITE_ASSET__C2GLdQxU__"